(ns common.schema.entities.counterparty-diligence.templates.capman.pep)

(def schema
  {:template/schema
   {:pep/first-names
    {:data-type :data.type/text-simple
     :label {:en "First name"
             :fi "Etunimi"}}

    :pep/middle-names
    {:data-type :data.type/text-simple
     :mandatoriness :mandatory/optional
     :label {:en "Middle names"
             :fi "Toiset nimet"}}

    :pep/last-name
    {:data-type :data.type/text-simple
     :label {:en "Last name"
             :fi "Sukunimi"}}

    :pep/connection-to-legal-entity
    {:data-type :data.type/text-simple
     :label {:en "Connection to legal entity"
             :fi "Yhteys oikeushenkilöön"}}

    :pep/relationship-to-pep
    {:data-type :data.type/keyword
     :label {:en "Relationship to PEP"
             :fi "Suhde PEP-henkilöön"}
     :options [{:value :self
                :label {:en "The person herself / himself is a PEP"
                        :fi "Henkilö itse"}}
               {:value :related-person
                :label {:en "Relative or an associate"
                        :fi "Läheinen tai lähipiiriin kuuluva henkilö"}}]}}

   :template/sections
   {:pep-information
    {:ord 0
     :title {:en "PEP information"
             :fi "PEP-tiedot"}
     :fields [:pep/first-names
              :pep/middle-names
              :pep/last-name
              :pep/connection-to-legal-entity
              :pep/relationship-to-pep]}}})
